import { useTranslation } from 'react-i18next';
import { useForm, useFormState } from 'react-final-form';
import React, { useRef } from 'react';
import { Select } from '../../../ui/Select';
import { NewRadioButton } from '../../../NewRadioButton';
import { LeasedFilterContainer } from './styled';
import { getLeasedTypesParams } from '../../../../utils/helpers/constants';
import { FilterFieldProps, SelectRefType } from '../types';
import useScreenSize from '../../../../hooks/useScreenSize';
import { useClient } from '../../../../hooks/useClient';
import { getBasedDataStatValueInFilters } from '../../../../utils/helpers/common';

export const LeasedFilter: React.FC<FilterFieldProps> = ({
  submitOnChange,
  isPashaLanding
}) => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const { change, submit } = useForm();
  const { isTablet } = useScreenSize();
  const isClient = useClient();
  const basedDataStat = getBasedDataStatValueInFilters(isPashaLanding);
  const leasedTypes = getLeasedTypesParams(basedDataStat);

  const selectRef = useRef<SelectRefType>(null);

  const leasedValue = values?.leased;
  const findLeasedValue = type => type.value === leasedValue;
  const selectedValue = leasedTypes.find(findLeasedValue)?.name;

  const handleChangeOption = (value: string) => {
    change('leased', value);

    if (selectRef.current) {
      selectRef.current?.closePopover();
    }

    if (submitOnChange) submit();
  };

  return (
    <Select
      ref={selectRef}
      placeholder=""
      value={t(selectedValue || '')}
      cypress={`${basedDataStat}-leased-filter`}
      width={isPashaLanding && isClient && !isTablet ? '100%' : 165}
      modalTitle={t('search.filters.dealType')}
      modalCypress="filter-modal"
      showModalHeaderBorder={!isPashaLanding}
    >
      <LeasedFilterContainer $isPashaLanding={isPashaLanding}>
        {leasedTypes.map(type => (
          <NewRadioButton
            key={type.id}
            data={{
              id: type.value,
              name: t(type.name)
            }}
            currentValue={leasedValue}
            onChangeHandler={() => handleChangeOption(type.value)}
            name={type.name}
            cypress={type.id}
            stat={type.id}
          />
        ))}
      </LeasedFilterContainer>
    </Select>
  );
};
